export const SOCIAL_CONFIG = {
  twitter: 'https://x.com/orderx',
  linkedin: 'https://www.linkedin.com/company/orderxtrading/',
}
